<template>
    <div class="home">
        <HelloWorld msg="Welcome to Cell BLAST" />
        <h3 style="color: #555; font-weight: 300">A BLAST-like Toolkit for scRNA-seq Data Querying and Annotation.</h3>
        <div style="display:flex;justify-content:space-between;padding-top:20px;padding-bottom:20px;margin: 0 auto;width:930px">
            <div>
                <span v-show="file" :class="{getObjectId2:true,tag:uploadTag}" @click="setUpload">UPLOAD</span>
                <span v-show="fields" :class="{getObjectId2:true,tag:BLASTTag}" @click="setBLAST">BLAST</span>
                <span v-show="result && !isBLASTJOBINFOSuccess" :class="{getObjectId2:true,tag:BLASTJOBINFOTag}" @click="setBLASTJOBINFO">BLAST JOB INFORMATION</span>
                <span v-show="isBLASTJOBINFOSuccess" :class="{getObjectId2:true,tag:PREDICTTag}" @click="setPREDICT">HITS</span>
                <span v-show="result1" :class="{getObjectId2:true,tag:PREDICTJOBINFOTag}" @click="setPREDICTJOBINFO">PREDICT</span>
            </div>
            <div>
                <span class="clearAll2" @click="reset" v-show="file">RESET ALL</span>
            </div>
        </div>
        <!-- start upload file -->
        <div v-show="uploadTag">
            <fieldset class="params" style="width: 910px">
                <legend class="legend" align="left">QUERY scRNA-seq DATA OR FETCH RESULT</legend>
                <div style="width: 710px; margin: 0 auto">
                    <span class="file-msg" style="font-size: .9rem; text-align: left; display: block;font-weight: bold;">Note:</span>
                    <span class="file-msg" style="font-size: 0.8rem; text-align: left; display: block;padding-left: 1rem">&#10003 Supported Format of Single-cell Expression Matrix File Includes CSV, TSV, h5ad and loom.</span>
                    <span class="file-msg" style="font-size: 0.8rem; text-align: left; display: block;padding-left: 1rem">&#10003 CSV and TSV Files Should Include Both Cell Names and Gene Names (e.g. TP53, NOT IDs Like ENSG00000141510).</span>
                    <span class="file-msg" style="font-size: 0.8rem; text-align: left; display: block;padding-left: 1rem">&#10003 The Number of Querying Cells is Currently Limited to 20000 in the Web Interface. See <a href="/FAQs#how-do-i-perform-querying">FAQs</a> for Details.</span>
                </div>
                <div v-drag-drop class="file-drop-area" id="drag">
                    <input v-focus class="url-input" id="text" type="text" placeholder="Type or Paste A Task ID to Fetch Cell BLAST Result Within A Week." v-model="UUID_sample">
                    <input :type="msg == 'file' ? 'file' : 'button'" ref="uploadfile" @change="onChangeFile" id="files" name="upload_file" class="file-input" accept=".csv,.tsv,.h5ad,.gz,.h5,.bz2,.xz" type="file">
                    <label v-show="!UUID_sample.length" for="files" id="choose" class="fake-btn">{{ msg }}</label>
                    <span v-show="UUID_sample.length" id="choose" class="fake-btn" @click="getResultByUUID">{{ msg }}</span>
                </div>
                <span class="file-msg">or Drag And Drop a Single-cell Expression Matrix File into the Dash-box Area</span>
                <div style="display: flex; flex-direction: row; justify-content: space-between; width: 710px; margin: 20px auto; height: 30px">
                    <a class="getObjectId1" style="width:180px" href="/segerstolpe_disease_gc.tsv.gz">DOWNLOAD A SAMPLE</a>
                    <div class="getObjectId1" style="width:120px" @click="showDemo">RUN A DEMO</div>
                    <div :class="{ getObjectId1 : UUID_sample === '', clear2: UUID_sample !== '' }" style="width:120px" @click="paste_UUID">{{ UUID_msg }}</div>
                </div>
            </fieldset>
            <div v-show="file" style="display: flex; flex-direction: column; justify-content: space-between; color: #FDA543; margin: 0 auto">
                <h3 v-show="!preview && !selected">Choose Orientation: <span class="upload" @click="upload('cg')">Cell by Gene</span> or <span class="upload" @click="upload('gc')">Gene by Cell</span> ?</h3>
                <h3 v-show="preview && selected && !fields">File parsing is done. Please check if it's the right orientation.</h3>
                <h3 v-show="uploadPercentage === 100 && !preview && selected">Parsing file content...</h3>
                <h3 v-show="uploadPercentage < 100 && selected">Waiting for Uploading...</h3>
                <progress v-show="!fields" style="display: flex; margin: 0 5px; width: 930px; justify-content: center; align-self: center;" max="100" :value.prop="uploadPercentage"></progress>
                <h2 v-show="uploadPercentage < 100">{{ uploadPercentage }} %</h2>
                <div class="load" v-show="!preview && selected && message.length === 0">
                    <hr />
                    <hr />
                    <hr />
                    <hr />
                </div>
            </div>
            <div v-show="preview && selected" style="justify-content: center; display: flex;">
                <br>
                <ul style="display: flex; flex-direction: row; justify-content: space-between; font-size: 13px; width: 930px;">
                    <li><span>File Name: </span><span style="color: #555">{{ file.name || 'segerstolpe_disease_gc.tsv.gz' }}</span></li>
                    <li><span>File Type: </span><span style="color: #555">{{ file.type || 'application/gzip'}}</span></li>
                    <li><span>File Size: </span><span style="color: #555">{{ file.size || 671114 | formatBytes }}</span></li>
                    <li><span>Cell Num: </span><span style="color: #555">{{ rows }}</span></li>
                    <li><span>Gene Num: </span><span style="color: #555">{{ columns }}</span></li>
                </ul>
                <br>
            </div>
            <div v-show="!preview && selected" style="justify-content: center; display: flex;">
                <div style="display: flex; flex-direction: column; margin-top: 40px;">
                    <h3 style="margin: 0; color: #F63D3A" v-for="m in message">{{ m }}</h3>
                </div>
            </div>
            <div style="justify-content: center; display: flex;">
                <div id="table">
                    <table id="customers" v-show="preview && selected" style="width: 930px;">
                        <thead>
                            <tr>
                                <th class="background" style="min-width: 147px;">
                                    <div><span class="bottom">Cell Names</span>
                                        <span class="top">Gene Names</span>
                                        <div class="line"></div>
                                    </div>
                                </th>
                                <th v-for="(c, key) in exprMatrix[0]" :key="key" v-if="key !== 'Cell Name'">{{key}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(c, key) in exprMatrix" :key="key">
                                <td v-for="(cell, key) in c">{{ cell }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br>
            <div style="display: flex; flex-direction: row; justify-content: space-around; width: 910px; margin: 0 auto">
                <div class="getObjectId" @click="showFields" v-show="preview && selected && !fields">CONFIRM</div>
            </div>
        </div>
        <!-- end upload file -->
        <!-- start blast -->
        <div v-show="BLASTTag && !uploadTag">
            <br v-show="preview && selected && fields">
            <fieldset class="params" v-show="preview && selected && fields" style="width:910px">
                <legend class="legend" align="left">CHOOSE REFERENCE PANEL</legend>
                <div style="display: flex; flex-direction: column; justify-content: flex-start;">
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">Organism: </span>
                        <div class="content">
                            <p>{{ hover.organism }}</p>
                        </div>
                        <select class="select-selected" v-model="organism">
                            <option :disabled="organism === ''" value="">Select One Organism</option>
                            <option v-for="o in organism_opts" :value="o">{{ o }}</option>
                        </select>
                    </div>
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">Organ: </span>
                        <div class="content">
                            <p>{{ hover.organ }}</p>
                        </div>
                        <select class="select-selected" v-model="organs">
                            <option :disabled="organs === ''" value="">Select One Organ</option>
                            <option v-for="o in organs_opts" :value="o">{{ o }}</option>
                        </select>
                    </div>
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">Reference Panel: </span>
                        <div class="content">
                            <p>{{ hover.reference_panel }}</p>
                        </div>
                        <select class="select-selected" v-model="datasets">
                            <option :disabled="datasets === ''" value="">Select One Reference</option>
                            <option v-for="d in datasets_opts" :value="d">{{ d }}</option>
                        </select>
                        <span class="clear" @click="clearOptions">CLEAR</span>
                    </div>
                    <div>{{datasets_meta_opts}}</div>
                </div>
            </fieldset>
            <br v-show="preview && selected && fields">
            <fieldset class="params" v-show="preview && datasets && fields" style="width:910px">
                <legend class="legend" align="left">SET GENERAL PARAMETERS</legend>
                <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                    <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">n_models: </span>
                    <input class="params2" type="text" v-model="n_models">
                    <div class="content">
                        <p>{{ hover.n_models }}</p>
                    </div>
                </div>
                <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                    <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">n_neighbors: </span>
                    <input class="params2" type="text" v-model="n_neighbors">
                    <div class="content">
                        <p>{{ hover.n_neighbors }}</p>
                    </div>
                    <span class="clear" @click="resetGeneralParameters">RESET</span>
                </div>
            </fieldset>
            <br v-show="preview && datasets && fields">
            <fieldset class="params1" v-show="additional" style="color: #FDA543;width: 910px">
                <legend style="font-size: .9rem; font-weight: bold; padding: 5px 15px; color: #fff; background-color: #FDA543; border: 1px solid #FDA543; border-radius: 3px; display: flex; justify-content: flex-start; align-items: flex-start; align-self: flex-start;" align="left">ADDITIONAL PARAMETERS</legend>
                <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                    <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">align_method: </span>
                    <div class="content">
                        <p>{{ hover.align_method }}</p>
                    </div>
                    <select class="select-selected1" v-model="align_method">
                        <option :disabled="align_method === ''" value="">ALL</option>
                        <option>MNNAdversarial</option>
                        <option>Adversarial</option>
                        <option>MNN</option>
                        <option>RMBatch</option>
                    </select>
                </div>
                <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                    <span class="trigger" style="font-size: .9rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">align_strength: </span>
                    <div class="content">
                        <p>{{ hover.align_strength }}</p>
                    </div>
                    <input class="params4" type="text" v-model="align_strength">
                </div>
                <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                    <span class="trigger" style="font-size: .9rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">align_batch_size: </span>
                    <div class="content">
                        <p>{{ hover.align_batch_size }}</p>
                    </div>
                    <input class="params4" type="text" v-model="align_batch_size">
                </div>
                <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                    <span class="trigger" style="font-size: .9rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">align_epochs: </span>
                    <div class="content">
                        <p>{{ hover.align_batch_size }}</p>
                    </div>
                    <input class="params4" type="text" v-model="align_epochs">
                    <span class="clear" @click="resetAdditionalParameters">RESET</span>
                </div>
            </fieldset>
            <!-- <br v-show="preview && datasets && fields"> -->
            <fieldset class="params1" style="width: 910px" v-show="preview && datasets && fields">
                <legend style="font-size: .9rem; font-weight: bold; padding: 5px 15px; color: #fff; background-color: #FDA543; border: 1px solid #FDA543; border-radius: 3px; display: flex; justify-content: flex-start; align-items: flex-start; align-self: flex-start;" align="left">SEND EMAIL WITH HITS OR PREDICT RESULT</legend>
                <div style="display: flex; flex-direction: column; justify-content: flex-start;">
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; color: #FDA543;font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">Email Address: </span>
                        <div class="content">
                            <p>{{ hover.email }}</p>
                        </div>
                        <input class="params4" type="email" v-model="email" name="email" placeholder="eg. example@mail.com">
                        <span class="clear" @click="clearEmail">CLEAR</span>
                    </div>
                </div>
            </fieldset>
            <br>
            <div style="display: flex; flex-direction: row; justify-content: space-around; width: 910px; margin: 0 auto">
                <div class="getObjectId" @click="loadDatasets" v-show="preview && datasets && fields">
                    <span>BLAST</span>
                    <span class="bottom-tooltips"></span>
                </div>
                <!-- <div class="clearAll" @click="reset" v-show="file">CLEAR ALL</div> -->
            </div>
            <div class="load" v-show="!blast && message.length === 0 && !Object.values(jobs_table).length">
                <hr />
                <hr />
                <hr />
                <hr />
            </div>
            <div v-show="!blast && !result" style="display: flex; flex-direction: column; margin-top: 40px;">
                <h3 style="margin: 0; color: #F63D3A" v-for="m in message">{{ m }}</h3>
            </div>
            <!-- end blast -->
        </div>
        <!-- </div> -->
        <!-- start blast job info -->
        <!-- <div v-show="!PREDICTTag"> -->
        <div v-show="PREDICTTag" style="display: flex;justify-content: space-between;flex-direction: row; width: 930px; margin: 0 auto">
            <div style="display: flex;justify-content: flex-start;flex-direction: row;">
                <span class="networkButton1" @click="showBLASTJOBINFO">{{ show_BLASTJOBINFO ? "HIDE" : "SHOW" }} BLAST JOB INFORMATION</span>
            </div>
        </div>
        
        <div v-show="show_BLASTJOBINFO">
            <div style="display: flex; flex-direction: column; justify-content: center; width: 930px; margin: 0 auto; color: #FDA543;border-radius: 3px">
                <table id="customers">
                    <tbody>
                        <tr v-for="(val, key) in jobs_table" style="border: 1px solid #FDA543">
                            <td style="background-color: #FDA543; color: #fff">
                                <span>{{ key }}</span>
                            </td>
                            <td>
                                <span>{{ val ? val : 'NULL'}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-show="PREDICTJOBINFOTag">
            <fieldset class="params" v-show="preview && datasets && fields" style="width:910px; margin-top:20px">
                    <legend style="font-size: .9rem; font-weight: bold; padding: 5px 15px; color: #fff; background-color: #09B07A; border: 1px solid #09B07A; border-radius: 3px; display: flex; justify-content: flex-start; align-items: flex-start; align-self: flex-start;" align="left">Predict Query Cells</legend>
                    <div style="display: flex; justify-content: flex-start; flex-direction: row">
                        <!-- <span class="getObjectId" @click="goOnline">PREDICT</span> -->
                        <span style="display: flex;padding: 5px 10px;margin: 10px 5px;" v-for=" checks in checkedNames">
                            <input type="checkbox" v-model="checks.active">
                            {{checks.name}}
                        </span>
                    </div>
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">majority_threshold: </span>
                        <div class="content">
                            <p>{{ hover.majority_threshold }}</p>
                        </div>
                        <input class="params2" type="text" v-model="majority_threshold">
                    </div>
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">min_hits: </span>
                        <div class="content">
                            <p>{{ hover.min_hits }}</p>
                        </div>
                        <input class="params2" type="text" v-model="min_hits">
                        <span style="margin-left: 173px;margin-right: 10px;" class="getObjectId" :class="{disabled : !checkedNames.filter(n => n.active).length }" @click="loadDatasets1">PREDICT</span>
                    </div>
                    <div class="tooltip left" style="display: flex; flex-direction: row; justify-content: flex-start; padding: 10px 0">
                        <span class="trigger" style="font-size: 1rem; font-weight: 700; width: 150px; margin-right: 10px; display: flex; justify-content: flex-start; align-items: center;">pval-cutoff: </span>
                        <input class="params2" type="text" v-model="cutoff">
                        <div class="content">
                            <p>{{ hover.min_hits }}</p>
                        </div>
                        <span class="clear" @click="resetGeneralParameters">RESET</span>
                    </div>
                </fieldset>
        </div>
        <!-- end blast job info -->
        <div class="load" v-show="loading && !isResult && !isError">
            <hr />
            <hr />
            <hr />
            <hr />
        </div>
        <br>
        <h1 style="font-weight: bold; color: #F63D3A;" v-show="isError">ERRORS, NO RESULTS</h1>
        <!-- <div v-show="isResult && !isError"> -->
        <!-- start predict -->
        <!-- <div style="display: flex; flex-direction:column; margin: 0 auto; width:910px"> -->
        <div v-show="PREDICTTag">
            <div style="display: flex; flex-direction:column; margin: 0 auto; width:930px">
                <!--                 <div style="display: flex; flex-direction: column; margin: 5px 0">
                    <div style="display: flex; flex-direction: column; ">
                        <div style="display: flex; width: 100%; height: 31px">
                            <span style="width:100%"><span class="number">1</span><span style="font-weight: bold; color: #FDA543; font-size: 1rem">Overview</span></span>
                        </div>
                        <div style="display: flex; width: 100%; height: 31px">
                            <span style="width:100%"><span style="font-weight: bold; color: #555; font-size: .8rem">Query File Name: </span><span style="font-weight: bold; color: #FDA543; font-size: .8rem">{{ file.name || 'segerstolpe_disease_gc.tsv.gz' }}</span></span>
                        </div>
                        <div id="table" class="scroll">
                            <table id="customers">
                                <thead>
                                    <tr>
                                        <th v-for="cols in Object.keys(query_table[0]||[])">
                                            <span style="font-size: .8rem">{{ cols === 'qid' ? 'Query Cell Name (' + query_table.length + ')': cols}}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td @click="cancelSelectedCell" :class="{ clearAll1: selectedCell === undefined, 'active-clearall': selectedCell !== undefined }"><span>Clear All</span></td>
                                    </tr>
                                    <tr v-for="q in query_table" @click="selectCell(q.qid)">
                                        <td v-for="cell in q" :class="{ 'active-tab': selectedCell == q.qid }"><span>{{ cell }} </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br>
                    <div style=" overflow-x: auto; overflow-y: hidden; min-width: 480px;">
                        <div style="display: flex; width: 100%; height: 31px">
                            <span style="width: 100%"><span class="number">2</span><span style="font-weight: bold; color: #FDA543; font-size: 1rem">Hits Table</span></span>
                        </div>
                        <div style="display: flex; width: 100%; height: 31px">
                            <span style="width: 100%"><span style="font-weight: bold; color: #555; font-size: .8rem">Reference Dataset Name: </span><span style="font-weight: bold; color: #FDA543; font-size: .8rem">{{ datasets }}</span></span>
                        </div>
                        <div id="table">
                            <table id="customers">
                                <thead>
                                    <tr>
                                        <th @click="sort(key)" style="cursor: pointer;" v-for="(c, key) in hits_table[0]" :key="key" v-if="key !== 'tSNE1' && key !== 'tSNE2' && key != 'hits' && key != 'index'">
                                            <span :class="{'sort-by': true, 'active': key !== currentSort, 'active-decs': 'asc' === currentSortDir && key === currentSort, 'active-acs': 'desc' === currentSortDir && key === currentSort }">{{ key }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="hit in hits_table" style="height: 50px">
                                        <td style="white-space: nowrap;" v-for="(h, key) in hit" v-if="key !== 'tSNE1' && key !== 'tSNE2' && key != 'hits' && key != 'index'">{{ h }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> -->
                <div style="display: flex; flex-direction: row; margin: 5px 0">
                    <div style="display: flex; flex-direction: column; width: 214px">
                        <div style="display: flex; width: 100%; height: 31px">
                            <span style="width:100%"><span class="number">1</span><span style="font-weight: bold; color: #FDA543; font-size: 1rem">Overview</span></span>
                        </div>
                        <div id="table" class="scroll">
                            <table id="customers" width="215">
                                <thead>
                                    <tr>
                                        <th>
                                            <span style="font-size: .8rem">{{ 'Query Cell Name (' + query_table.length + ')'}}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td @click="cancelSelectedCell" :class="{ clearAll1: selectedCell === undefined, 'active-clearall': selectedCell !== undefined }"><span>Clear All</span></td>
                                    </tr>
                                    <tr v-for="q in query_table" @click="selectCell(q.qid)">
                                        <td :class="{ 'active-tab': selectedCell == q.qid }"><span>{{ q.qid }} ({{q.count}})</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div style=" overflow-x: auto; overflow-y: hidden; margin-left: 5px">
                        <div style="display: flex; width: 100%; height: 31px">
                            <span style="width: 100%"><span class="number">2</span><span style="font-weight: bold; color: #FDA543; font-size: 1rem">Hits Table</span></span>
                        </div>
                        <div id="table">
                            <table id="customers">
                                <thead>
                                    <tr>
                                        <th @click="sort(key)" style="cursor: pointer;" v-for="(c, key) in hits_table[0]" :key="key" v-if="key !== 'tSNE1' && key !== 'tSNE2' && key != 'hits' && key != 'index'">
                                            <span :class="{'sort-by': true, 'active': key !== currentSort, 'active-decs': 'asc' === currentSortDir && key === currentSort, 'active-acs': 'desc' === currentSortDir && key === currentSort }">{{ key }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="hit in hits_table" style="height: 50px">
                                        <td style="white-space: nowrap;" v-for="(h, key) in hit" v-if="key !== 'tSNE1' && key !== 'tSNE2' && key != 'hits' && key != 'index'">{{ h }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
                <div>
                    <div style="display: flex;justify-content: space-between;flex-direction: row;">
                        <div style="display: flex;justify-content: flex-start;flex-direction: row;">
                            <a class="networkButton" style="display: flex;" :href="downloadPath" download>DOWNLOAD HITS</a>
                        </div>
                        <span style="display: flex; padding: 15px 0px; font-weight: bold; margin-left:80px;">
                            <span style="cursor: pointer;" @click="prevPage"><img src="/left-arrow.svg" style="width: 10px; font-size: 0.8rem">PREV (</span>
                            <span id="page">{{ currentPage }} of {{ Math.ceil(numOfHits / 5) }} </span>
                            <span style="cursor: pointer;" @click="nextPage"> ) NEXT<img src="/right-arrow.svg" style="width: 10px; font-size: 0.8rem"></span>
                        </span>
                    </div>
                </div>
                <div>
                    <div style="display: flex;justify-content: space-between;flex-direction: row;">
                        <div style="display: flex;justify-content: flex-start;flex-direction: row;">
                            <span class="networkButton1" @click="goOnline">GO ONLINE TUNING FOR MORE HITS</span>
                        </div>
                        <div style="display: flex;justify-content: flex-start;flex-direction: row;">
                            <span class="networkButton" @click="setPREDICTJOBINFO">PREDICT</span>
                        </div>
                        <!--                         <span style="display: flex; padding: 15px 0px; font-weight: bold; margin-left:80px;">
                            <span style="cursor: pointer;" @click="prevPage"><img src="/left-arrow.svg" style="width: 10px">Prev Page (</span>
                            <span id="page">{{ currentPage }} of {{ Math.ceil(numOfHits / 5) }} </span>
                            <span style="cursor: pointer;" @click="nextPage"> ) Next Page <img src="/right-arrow.svg" style="width: 10px"></span>
                        </span> -->
                    </div>
                </div>
                <div v-show="network_graph" style="display: flex; flex-direction: row; justify-content: flex-start;">
                    <div id="tooltips" class="tooltips">
                        <span style="width: 580px"><span class="number">3</span><span style="font-weight: bold; color: #FDA543; font-size: 1rem">View Hits As A Graph</span></span>
                        <br>
                        <div class="start">
                            <span style="padding-right: 10px; color: #555; font-weight: bold;">Id: </span>
                            <span style="padding-right: 10px">{{ tooltips.id || "Cell Id" }}</span>
                        </div>
                        <div class="start">
                            <span style="padding-right: 10px; color: #555; font-weight: bold;">Cell_ontology_class: </span>
                            <span style="padding-right: 10px">{{ tooltips.cell_ontology_class || "Cell Ontology Class" }}</span>
                        </div>
                        <div class="start">
                            <span style="padding-right: 10px; color: #555; font-weight: bold;">Count: </span>
                            <span style="padding-right: 10px">{{ tooltips.count || 0 }}</span>
                        </div>
                        <div class="start">
                            <span style="padding-right: 10px; color: #555; font-weight: bold;">Raw Count: </span>
                            <span style="padding-right: 10px">{{ tooltips.raw_count || 0 }}</span>
                        </div>
                        <div class="start">
                            <span style="padding-right: 10px; color: #555; font-weight: bold;">Synonyms: </span>
                            <ul style="padding-right: 10px; display: block; list-style-type: circle;">
                                <li v-for="(s, n) in tooltips.synonyms" style="display: block; padding: 0px 0px 5px 5px;">{{n+1}}. {{ s || "None" }}</li>
                            </ul>
                        </div>
                        <div class="start" style="text-align: left;">
                            <span style="padding-right: 10px; color: #555; font-weight: bold;">Description: </span>
                            <span style="padding-right: 10px;">{{ tooltips.description || "None" }}</span>
                        </div>
                        <br>
                        <div class="start" style="text-align: left;">
                            <input type="radio" id="one" value="count" v-model="picked">
                            <label for="one">Count</label>
                            <input type="radio" id="two" value="raw_count" v-model="picked">
                            <label for="two">Raw Count</label>
                        </div>
                        <br>
                        <div class="start" style="text-align: left;">
                            <svg width="400" height="90" id="scale-legend">
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                        <stop v-for="i in 10" :offset="i*10 + '%'" :stop-color="interpolateYlOrRdColor(i/10,1)"></stop>
                                    </linearGradient>
                                </defs>
                                <rect x="20" class="legend-scale" width="350" height="25" transform="translate(0,20)" style="fill: url(#linear-gradient);"></rect><text class="legend-text" x="20" y="16" style="text-anchor: middle;">0</text><text class="legend-text" x="370" y="16" style="text-anchor: middle;">{{max}}</text><text v-show="picked === 'count'" :x="20 + (tooltips.count ? (tooltips.count/max)*350 : 0)" y="68" style="text-anchor: middle;">{{ tooltips.count }}</text><text v-show="picked !== 'count'" :x="20 + (tooltips.raw_count ? (tooltips.raw_count/max)*350 : 0)" y="68" style="text-anchor: middle;">{{ tooltips.raw_count }}</text>
                                <polygon v-show="picked === 'count'" :transform="'translate(' + (15 + (tooltips.count ? (tooltips.count/max)*350 : 0)) + ',' + 45 +')'" points="4,0 8,8 0,8" />
                                <polygon v-show="picked !== 'count'" :transform="'translate(' + (15 + (tooltips.raw_count ? (tooltips.raw_count/max)*350 : 0)) + ',' + 45 +')'" points="4,0 8,8 0,8" />
                            </svg>
                        </div>
                    </div>
                    <div style="justify-content: center; display: flex;">
                        <svg id='viz' class="viz grabbable">
                            <defs>
                                <marker id="arrow" viewBox="0 -5 10 10" refX="20" refY="0" markerWidth="6" markerHeight="6" orient="auto">
                                    <path d="M0,-5L10,0L0,5" fill="#888"></path>
                                </marker>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <!-- end predict -->
        </div>
        <br>
    </div>
</template>
<script>
import HelloWorld from '@/components/HelloWorld.vue'
import * as d3 from 'd3'

const URI = window.location.href.match('localhost') ? '' : window.location.href

export default {
    name: 'home',
    components: {
        HelloWorld
    },
    data: function data() {
        return {
            msg: 'Choose File',
            uploadPercentage: 0,
            file: '',
            columns: 0,
            rows: 0,
            exprMatrix: [],
            textarea_input: "",
            formError: false,
            organism: "",
            organs: "",
            datasets: "",
            organism_opts: "",
            organs_opts: "",
            datasets_opts: "",
            md5: "52223b84fe7c01445595d77227625665gc",
            preview: false,
            selected: false,
            message: [],
            n_neighbors: 5,
            n_models: 2,
            min_hits: 2,
            cutoff: 0.05,
            selectedCategory: undefined,
            selectedCell: undefined,
            categories: [],
            networkGraph: [],
            header: [],
            currentSort: 'pval',
            currentSortDir: 'asc',
            pageSize: 5,
            currentPage: 1,
            numOfHits: 0,
            tooltips: {
                count: 0,
                raw_count: 0
            },
            result: false,
            blast: true,
            loading: false,
            networkButton: "Generate",
            network_graph: false,
            datasets_opts: [],
            fields: false,
            networkGraph: {},
            picked: 'count',
            max: 0,
            range: [],
            additional: false,
            align_method: '',
            align_strength: 0.01,
            align_batch_size: 256,
            align_epochs: 100,
            majority_threshold: 0.5,
            demo: false,
            demoCount: 0,
            hover: '',
            datasets_meta: '',
            jobs_table: [],
            uuid: '',
            pred_table: [],
            query_table: [],
            hits_table: [],
            cellType: '',
            email: undefined,
            isResult: false,
            downloadPath: '',
            UUID_sample: '',
            UUID_msg: 'TRY A TASK ID',
            isError: false,
            checkedNames: [],
            isUploadSuccess: false,
            isBLASTSuccess: false,
            isBLASTJOBINFOSuccess: false,
            isPREDICTSuccess: false,
            isPREDICTJOBINFOSuccess: false,
            uploadTag: true,
            BLASTTag: false,
            BLASTJOBINFOTag: false,
            PREDICTTag: false,
            PREDICTJOBINFOTag: false,
            result1: false,
            show_BLASTJOBINFO: true,
            // uri: 'http://114.115.133.146:3001/'
            uri: 'http://49.4.21.8:3001/'
            // uri: ''
        }
    },
    computed: {
        datasets_meta_opts() {
            let _this = this
            _this.$http.post(_this.uri + 'datasets_opts', {
                    organ: _this.organs,
                    organism: _this.organism,
                    dataset_name: _this.datasets
                })
                .then((res) => {
                    let datasets_opts = res.data
                    _this.organism_opts = [...new Set(datasets_opts.map(({ organism }) => organism))]
                    _this.organs_opts = [...new Set(datasets_opts.map(({ organ }) => organ))]
                    _this.datasets_opts = datasets_opts.map(({ dataset_name }) => dataset_name)
                    if (_this.organism_opts.length === 1) _this.organism = _this.organism_opts[0]
                    if (_this.organs_opts.length === 1) _this.organs = _this.organs_opts[0]
                    if (_this.datasets_opts.length === 1) _this.datasets = _this.datasets_opts[0]
                }).catch((err) => {
                    console.log(err)
                })
        }
    },
    methods: {
        showBLASTJOBINFO() {
            this.show_BLASTJOBINFO = !this.show_BLASTJOBINFO
        },
        setUpload() {
            this.uploadTag = true
            this.BLASTTag = false
            this.BLASTJOBINFOTag = false
            this.PREDICTTag = false
            this.PREDICTJOBINFOTag = false
        },
        setBLAST() {
            this.uploadTag = false
            this.BLASTTag = true
            this.BLASTJOBINFOTag = false
            this.PREDICTTag = false
            this.PREDICTJOBINFOTag = false
        },
        setBLASTJOBINFO() {
            this.uploadTag = false
            this.BLASTTag = false
            this.BLASTJOBINFOTag = true
            this.PREDICTTag = false
            this.PREDICTJOBINFOTag = false
        },
        setPREDICT() {
            this.uploadTag = false
            this.BLASTTag = false
            this.BLASTJOBINFOTag = false
            this.PREDICTTag = true
            this.PREDICTJOBINFOTag = false
        },
        setPREDICTJOBINFO() {
            this.uploadTag = false
            this.BLASTTag = false
            this.BLASTJOBINFOTag = false
            this.PREDICTTag = false
            this.PREDICTJOBINFOTag = true
            this.result1 = true
        },
        showDemo() {
            this.demo = true
            this.demoCount++
            this.file = { name: 'startDemo' }
            this.organism = "Homo sapiens"
            this.organs = "Pancreas"
            this.datasets = "Baron_human"
            this.upload()
        },
        paste_UUID() {
            if (this.UUID_sample === '') {
                this.UUID_sample = "d1273b4d-e518-4ca7-be7c-3f9a4daa5e14"
                // this.UUID_sample = "c626697c-28e9-4814-bc6d-f2aa9447a644"
                this.UUID_msg = "CLEAR TASK ID"
                this.msg = "FETCH RESULT"
            } else {
                this.UUID_sample = ''
                this.UUID_msg = "TRY A TASK ID"
                this.msg = "Choose File"
            }
        },
        getResultByUUID() {
            let _this = this
            _this.result = true
            _this.$http.post(this.uri + 'getJob', {
                uuid: _this.UUID_sample
            }).then((res) => {
                console.log(res.data)
                _this.jobs_table = res.data
                _this.md5 = _this.jobs_table.md5
                return res.data
            }).then((res) => {
                _this.uuid = _this.UUID_sample
                _this.downloadPath = '/' + _this.md5 + '/cblast_' + _this.uuid + '.csv'
                _this.datasets = res.reference
                // _this.pred()
                _this.query()
            }).catch((e) => {
                console.log(e)
                _this.message = "There is no result corresponding to the UUID you submitted. Please check if it's a valid UUID."
            })
        },
        sort: function(s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = s;
            this.table1()
        },
        clearEmail() {
            this.email = ''
        },
        activeColor(max) {
            return d3.scaleLinear().domain([0, max]).range([0, 1])
        },
        interpolateYlOrRdColor(num, max) {
            let color = this.activeColor(max)
            return d3.interpolateYlOrRd(color(num))
        },
        cancelSelectedCategory() {
            this.selectedCategory = undefined
            this.selectedCell = undefined
            this.currentPage = 1
            this.query()
        },
        selectCategory(category) {
            this.selectedCategory = category
            this.selectedCell = undefined
            this.currentPage = 1
            this.query()
        },
        selectCell(qid) {
            this.selectedCell = qid
            this.currentPage = 1
            this.table()
        },
        cancelSelectedCell() {
            this.selectedCell = undefined
            this.currentPage = 1
            this.table()
        },
        showFields() {
            this.fields = true
            this.isUploadSuccess = true
            this.uploadTag = false
            this.BLASTTag = true
        },
        clearOptions() {
            this.datasets = ''
            this.organs = ''
            this.organism = ''
        },
        reset: function() {
            this.msg = 'Choose file'
            this.uploadPercentage = 0
            this.file = ''
            this.columns = 0
            this.rows = 0
            this.exprMatrix = []
            this.textarea_input = ""
            this.formError = false
            this.organism = ""
            this.organs = ""
            this.datasets = ""
            this.md5 = ""
            this.preview = false
            this.selected = false
            this.message = []
            this.n_neighbors = 5
            this.min_hits = 2
            this.cutoff = 0.05
            this.selectedCategory = undefined
            this.selectedCell = undefined
            this.categories = []
            this.networkGraph = []
            this.header = []
            this.currentSort = 'pval'
            this.currentSortDir = 'asc'
            this.pageSize = 5
            this.currentPage = 1
            this.numOfHits = 0
            this.tooltips = {
                count: 0,
                raw_count: 0
            }
            this.result = false
            this.blast = true
            this.loading = false
            this.networkButton = "Generate"
            this.network_graph = false
            this.fields = false
            this.$refs.uploadfile.value = null
            this.networkGraph = {}
            this.picked = 'count'
            this.max = 0
            this.range = []
            this.additional = false
            this.align_method = ''
            this.align_strength = 0.01
            this.align_batch_size = 256
            this.align_epochs = 100
            this.demo = false
            this.demoCount = 0
            this.jobs_table = []
            this.uuid = ''
            this.pred_table = []
            this.query_table = []
            this.hits_table = []
            this.cellType = ''
            this.email = undefined
            this.isResult = false
            this.isError = false
            this.downloadPath = ''
            this.isUploadSuccess = false
            this.isBLASTSuccess = false
            this.isBLASTJOBINFOSuccess = false
            this.isPREDICTSuccess = false
            this.isPREDICTJOBINFOSuccess = false
            this.uploadTag = true
            this.BLASTTag = false
            this.BLASTJOBINFOTag = false
            this.PREDICTTag = false
            this.PREDICTJOBINFOTag = false
            this.result1 = false
            this.show_BLASTJOBINFO = true
        },
        setResult: function() {
            this.result = !this.result
        },
        goOnline: function() {
            // this.result = !this.result
            this.setBLAST()
            this.additional = true
            this.align_method = 'MNNAdversarial'
        },
        nextPage: function() {
            if ((this.currentPage * this.pageSize) < this.numOfHits) this.currentPage += 1;
            // this.table()
            this.table1()
        },
        prevPage: function() {
            if (this.currentPage > 1) this.currentPage -= 1;
            // this.table()
            this.table1()
        },
        onChangeFile: function(evt) {
            var _this = this;
            _this.file = evt.target.files[0]
            console.log(_this.file)
            let ext = _this.file.name.split('.').pop()
            if (ext === 'loom' || ext === 'h5' || ext === 'h5ad') {
                this.upload('cg')
            }
        },
        upload: function(choice) {
            let _this = this;
            _this.selected = true
            let formData = new FormData()
            formData.append('file', _this.file)
            formData.set('choices', choice)
            formData.set('filename', _this.file.name)
            formData.set('demo', _this.demo)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function(progressEvent) {
                    _this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                }
            };
            this.$http.post(this.uri + 'upload', formData, config)
                .then((res) => {
                    let result = res.data
                    console.log(result)
                    _this.preview = result.status
                    if (result.status) {
                        _this.exprMatrix = result.data
                        _this.md5 = res.data.md5
                        _this.rows = res.data.ncell
                        _this.columns = res.data.ngene
                    } else {
                        _this.message = result.message
                    }
                })
                .catch((err) => {
                    console.log(err)
                    console.log('FAILURE!!');
                });
        },
        loadDatasets: function() {
            var _this = this
            let selections = {
                md5: _this.md5,
                datasets: _this.datasets,
                n_neighbors: _this.n_neighbors,
                n_models: _this.n_models,
                min_hits: _this.min_hits,
                cutoff: _this.cutoff,
                align_method: _this.align_method,
                align_strength: _this.align_strength,
                align_batch_size: _this.align_batch_size,
                align_epochs: _this.align_epochs,
                filename: _this.file.name,
                email: _this.email
            }
            _this.BLASTJOBINFOTag = true
            _this.blast = false
            _this.isResult = false
            _this.loading = true
            _this.message = []
            _this.BLASTTag = false
            _this.result = true

            _this.$http.post(this.uri + 'submit', selections)
                .then((res) => {
                    console.log(res.data)
                    _this.jobs_table = res.data
                    return res.data.uuid
                }).then((uuid) => {
                    _this.uuid = uuid
                    _this.downloadPath = '/' + _this.uuid + '.csv.gz'
                    // var wsUrl = "ws://114.115.133.146:3000/"
                    var wsUrl = "ws://49.4.21.8:3001/jobs"
                    var lockReconnect = false; //避免重复连接
                    var tt = null
                    var ws = null

                    var heartCheck = {
                        timeout: 3000, //每隔三秒发送心跳
                        severTimeout: 5000, //服务端超时时间
                        timeoutObj: null,
                        serverTimeoutObj: null,
                        start: function() {
                            var _this = this;
                            this.timeoutObj && clearTimeout(this.timeoutObj);
                            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
                            this.timeoutObj = setTimeout(function() {
                                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                                //onmessage拿到返回的心跳就说明连接正常
                                ws.send(uuid.toString())
                                //计算答复的超时时间
                            }, this.timeout)
                        }
                    }

                    function reconnect(url) {
                        if (lockReconnect) {
                            return;
                        };
                        lockReconnect = true;
                        //没连接上会一直重连，设置延迟避免请求过多
                        tt && clearTimeout(tt);
                        tt = setTimeout(function() {
                            createWebSocket(url);
                            lockReconnect = false;
                        }, 4000);
                    }

                    function createWebSocket() {
                        try {
                            ws = new WebSocket(wsUrl);
                            init();
                        } catch (e) {
                            console.log(e)
                            console.log('catch');
                            reconnect(wsUrl);
                        }
                    }

                    function init() {
                        ws.onclose = function() {
                            console.log('链接关闭');
                            reconnect(wsUrl);
                        };
                        ws.onerror = function() {
                            console.log('发生异常了');
                            reconnect(wsUrl);
                        };
                        ws.onopen = function() {
                            //心跳检测重置
                            ws.send(uuid.toString())
                        };
                        ws.onmessage = function(evt) {
                            console.log('接收到消息');
                            // heartCheck.start();
                            _this.loading = false
                            console.log(JSON.parse(evt.data))
                            _this.jobs_table = JSON.parse(evt.data)
                            if (_this.jobs_table.status === 'finished') {
                                _this.isBLASTJOBINFOSuccess = true
                                _this.PREDICTTag = true
                                _this.BLASTJOBINFOTag = false
                                _this.show_BLASTJOBINFO = false
                            }
                            if (_this.jobs_table.status !== 'error') {
                                // _this.pred()
                                _this.query_predictType()
                                _this.query()
                            } else {
                                _this.isError = true
                            }
                            lockReconnect = true;
                            ws.close()
                        }
                    }

                    createWebSocket()
                })
        },
        loadDatasets1: function() {
            var _this = this
            let selections = {
                uuid: _this.uuid,
                annotateFields: _this.checkedNames.filter(c => c.active).map(c => c.name),
                pvalCutoff: _this.cutoff,
                minHits: _this.min_hits,
                majorityThreshold: _this.majority_threshold
            }
            console.log(selections)
            _this.blast = false
            _this.isResult = false
            _this.loading = true
            _this.message = []
            _this.result1 = true

            _this.$http.post(this.uri + 'predict', selections)
                .then((res) => {
                    console.log(res.data)
                    _this.pred_table = res.data
                    // _this.result = true
                    // return res.data.uuid
                }).then((uuid) => {
                    // _this.uuid = uuid
                    // _this.downloadPath = '/' + _this.md5 + '/cblast_' + _this.uuid + '.csv'
                    // var wsUrl = "ws://114.115.133.146:3000/"
                    var wsUrl = "ws://49.4.21.8:3001/predict_jobs"
                    var lockReconnect = false; //避免重复连接
                    var tt = null
                    var ws = null

                    var heartCheck = {
                        timeout: 3000, //每隔三秒发送心跳
                        severTimeout: 5000, //服务端超时时间
                        timeoutObj: null,
                        serverTimeoutObj: null,
                        start: function() {
                            var _this = this;
                            this.timeoutObj && clearTimeout(this.timeoutObj);
                            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
                            this.timeoutObj = setTimeout(function() {
                                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                                //onmessage拿到返回的心跳就说明连接正常
                                console.log(_this.uuid)
                                ws.send(_this.uuid.toString())
                                //计算答复的超时时间
                            }, this.timeout)
                        }
                    }

                    function reconnect(url) {
                        if (lockReconnect) {
                            return;
                        };
                        lockReconnect = true;
                        //没连接上会一直重连，设置延迟避免请求过多
                        tt && clearTimeout(tt);
                        tt = setTimeout(function() {
                            createWebSocket(url);
                            lockReconnect = false;
                        }, 4000);
                    }

                    function createWebSocket() {
                        try {
                            ws = new WebSocket(wsUrl);
                            init();
                        } catch (e) {
                            console.log(e)
                            console.log('catch');
                            reconnect(wsUrl);
                        }
                    }

                    function init() {
                        ws.onclose = function() {
                            console.log('链接关闭');
                            reconnect(wsUrl);
                        };
                        ws.onerror = function() {
                            console.log('发生异常了');
                            reconnect(wsUrl);
                        };
                        ws.onopen = function() {
                            //心跳检测重置
                            ws.send(_this.uuid.toString())
                        };
                        ws.onmessage = function(evt) {
                            console.log('接收到消息');
                            // heartCheck.start();
                            console.log(JSON.parse(evt.data))
                            _this.pred_table = JSON.parse(evt.data)
                            if (_this.jobs_table.status === 'finished') {
                                _this.isPREDICTJOBINFOSuccess = true
                                _this.PREDICTTag = true
                                _this.PREDICTJOBINFOTag = false
                            }
                            if (_this.pred_table.status !== 'error') {
                                // _this.pred()
                                _this.query()
                            } else {
                                _this.isError = true
                            }
                            lockReconnect = true;
                            ws.close()
                        }
                    }

                    createWebSocket()
                })
        },
        // pred: function() {
        //     let _this = this
        //     _this.$http.post(this.uri + 'pred', {
        //             uuid: _this.uuid
        //         })
        //         .then((res) => {
        //             console.log(res.data)
        //             _this.pred_table = res.data
        //         }).
        //     then((res) => {
        //         _this.query()
        //     })
        // },
        predict: function() {
            let _this = this
            _this.$http.post(this.uri + 'predict')
        },
        query: function() {
            let _this = this
            _this.$http.post(this.uri + 'hits', {
                uuid: _this.uuid,
                cellType: _this.selectedCategory,
                checkedNames: _this.checkedNames
            }).then((res) => {
                _this.query_table = res.data
                console.log(_this.query_table)
            }).then((res) => {
                // _this.query_predictType()
                _this.table1()
            })
        },
        query_predictType: function() {
            let _this = this
            _this.$http.post(this.uri + 'predictType', {
                dataset: _this.datasets
            }).then((res) => {
                _this.checkedNames = res.data[0].predictable.split(', ').map(p => {
                    return { name: p, active: false }
                })
            })
        },
        table1: function() {
            let _this = this
            console.log('table')
            _this.$http.post(this.uri + 'hits_table1', {
                dataset: _this.datasets,
                uuid: _this.uuid,
                cellType: _this.selectedCategory,
                qid: _this.selectedCell,
                sortBy: _this.currentSort,
                dir: _this.currentSortDir,
                offset: (_this.currentPage - 1) * _this.pageSize,
                limit: _this.pageSize
            }).then((res) => {
                let result = res.data
                let size = result.pop()
                _this.numOfHits = size.count
                console.log(_this.numOfHits)
                _this.hits_table = result
                _this.isResult = true
            })
        },
        table: function() {
            let _this = this
            console.log('table')
            _this.$http.post(this.uri + 'hits_table', {
                dataset: _this.datasets,
                uuid: _this.uuid,
                cellType: _this.selectedCategory,
                qid: _this.selectedCell,
                sortBy: _this.currentSort,
                dir: _this.currentSortDir,
                offset: (_this.currentPage - 1) * _this.pageSize,
                limit: _this.pageSize
            }).then((res) => {
                let result = res.data
                let size = result.pop()
                _this.numOfHits = size.count
                console.log(_this.numOfHits)
                _this.hits_table = result
                _this.isResult = true
            })
        },
        network: function() {
            var _this = this;
            let selections = {
                md5: _this.md5,
                uuid: _this.uuid,
                cellType: _this.selectedCategory,
                dataset: _this.datasets,
                qid: _this.selectedCell
            }

            _this.$http.post(this.uri + 'network', selections)
                .then((res) => {
                    _this.networkButton = "Reset"
                    _this.network_graph = true
                    let graph = res.data
                    console.log(graph)
                    let max_count = Math.max.apply(Math, graph.nodes.map((o) => { return o.count }))
                    let min_count = Math.min.apply(Math, graph.nodes.map((o) => { return o.count }))
                    let max_raw_count = Math.max.apply(Math, graph.nodes.map((o) => { return o.raw_count }))
                    let min_raw_count = Math.min.apply(Math, graph.nodes.map((o) => { return o.raw_count }))

                    let min = _this.picked === 'count' ? min_count : min_raw_count
                    _this.max = _this.picked === 'count' ? max_count : max_raw_count
                    console.log(_this.max)
                    _this.range = d3.range(_this.max + 1)

                    var width = 970;
                    var height = 870;
                    var color = d3.scaleLinear().domain([min, _this.max])
                        .range([0, 1]);

                    var labelLayout = d3.forceSimulation()
                        .force("charge", d3.forceManyBody())
                        .force("link", d3.forceLink())
                        .force("center", d3.forceCenter(width / 2, height / 2))

                    var graphLayout = d3.forceSimulation()
                        .force("charge", d3.forceManyBody().strength(-250))
                        .force("center", d3.forceCenter(width / 2, height / 2))
                        .force("link", d3.forceLink().id(function(d) { return d.id; }).distance(70).strength(0.7))

                    var labels = []

                    graph.nodes.forEach(function(d) {
                        labels.push({ node: d });
                    });

                    graphLayout.nodes(graph.nodes)
                        .on("tick", ticked);

                    graphLayout.force("link")
                        .links(graph.links);

                    labelLayout.nodes(labels)

                    var adjlist = [];

                    graph.links.forEach(function(d) {
                        adjlist[d.source.index + "-" + d.target.index] = true;
                        adjlist[d.target.index + "-" + d.source.index] = true;
                    });

                    function neigh(a, b) {
                        return a == b || adjlist[a + "-" + b];
                    }

                    var svg = d3.select("#viz").attr("width", width).attr("height", height);
                    svg.select('g').remove()
                    var container = svg.append("g");

                    // Zoom Effect
                    svg.call(
                        d3.zoom()
                        .scaleExtent([.5, 4])
                        .on("zoom", function() { container.attr("transform", d3.event.transform); })
                    );

                    var link = container.append("g").attr("class", "links")
                        .selectAll("line")
                        .data(graph.links)
                        .enter()
                        .append("line")
                        .attr("marker-end", "url(#arrow)");

                    var node = container.append("g").attr("class", "nodes")
                        .selectAll("g")
                        .data(graph.nodes)
                        .enter()
                        .append("circle")
                        .attr("r", 10)
                        .attr("fill", function(d) {
                            return _this.interpolateYlOrRdColor(d[_this.picked], _this.max)
                        })

                    var labelNode = container.append("g").attr("class", "labelNodes")
                        .selectAll("text")
                        .data(labels)
                        .enter()
                        .append("text")
                        .text(function(d, i) { return d.node.cell_ontology_class; })

                    node.on("mouseover", focus)
                        .on("mouseout", unfocus);

                    node.call(
                        d3.drag()
                        .on("start", dragstarted)
                        .on("drag", dragged)
                        .on("end", dragended)
                    );

                    function ticked() {
                        node.call(updateNode);
                        link.call(updateLink);
                        labelLayout.alphaTarget(0.3).restart();
                        labelNode.each(function(d, i) {
                            d.x = d.node.x + 5;
                            d.y = d.node.y - 15;
                            this.setAttribute("transform", "translate(" + d.x + "," + d.y + ")");
                        });
                        labelNode.call(updateNode);
                    }

                    function fixna(x) {
                        if (isFinite(x)) return x;
                        return 0;
                    }

                    function focus(i) {
                        if (i) index = i
                        var index = d3.select(d3.event.target).datum().index
                        node.style("opacity", function(o) {
                            if (index == o.index) {
                                _this.tooltips = o
                            }
                            return neigh(index, o.index) ? 1 : 0.2
                        });
                        link.style("opacity", function(o) {
                            return o.target.index == index || o.source.index == index ? 1 : 0.2;
                        });
                        labelNode.attr("display", function(o) {
                            return neigh(index, o.node.index) ? "block" : "none";
                        });
                    }

                    function unfocus() {
                        labelNode.attr("display", "block");
                        node.style("opacity", 1);
                        link.style("opacity", 1);
                        labelNode.style("opacity", 1)
                    }

                    function updateLink(link) {
                        link.attr("x1", function(d) { return fixna(d.source.x); })
                            .attr("y1", function(d) { return fixna(d.source.y); })
                            .attr("x2", function(d) { return fixna(d.target.x); })
                            .attr("y2", function(d) { return fixna(d.target.y); });
                    }

                    function updateNode(node) {
                        node.attr("transform", function(d) {
                            return "translate(" + fixna(d.x) + "," + fixna(d.y) + ")";
                        });
                    }

                    function dragstarted(d) {
                        d3.event.sourceEvent.stopPropagation();
                        if (!d3.event.active) graphLayout.alphaTarget(0.3).restart();
                        d.fx = d.x;
                        d.fy = d.y;
                    }

                    function dragged(d) {
                        d.fx = d3.event.x;
                        d.fy = d3.event.y;
                    }

                    function dragended(d) {
                        if (!d3.event.active) graphLayout.alphaTarget(0);
                        d.fx = null;
                        d.fy = null;
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        },
        resetGeneralParameters() {
            this.n_neighbors = 5
            this.min_hits = 2
            this.cutoff = 0.05
        },
        resetAdditionalParameters() {
            this.align_method = ""
            this.align_strength = 0.01
            this.align_batch_size = 256
            this.align_epochs = 100
        }
    },
    created: function beforeCreate() {
        let _this = this

        function getHover() {
            return _this.$http.get(_this.uri + 'hover.json');
        }

        _this.$http.all([getHover()])
            .then(_this.$http.spread(function(hover, datasetsMeta) {
                _this.hover = hover.data
            }));
    }
}
</script>
<style scoped>
section {
    flex-grow: 1;
}

#drag {
    margin: 0 auto;
}

.disabled {
    opacity: 0.65;
    pointer-events: none;
    cursor: not-allowed;
}

.file-drop-area {
    position: relative;
    display: flex;
    align-items: center;
    width: 550px;
    max-width: 100%;
    padding: 40px 80px;
    border: 1px dashed #09B07A;
    border-radius: 3px;
    transition: 0.2s;
}

.file-drop-area.is-active {
    border: 1px solid #09B07A;
    background-color: lightgrey;
    z-index: 1000
}

.fake-btn {
    flex-shrink: 0;
    background-color: #09B07A;
    width: 90px;
    color: #fff;
    border: 0px solid #09B07A;
    border-radius: 3px;
    padding: 8px 10px;
    margin-left: 10px;
    font-size: .78rem;
    font-weight: 700;
    text-transform: uppercase;
    z-index: 100;
    cursor: pointer;
    transition: 0.2s;
}

.file-msg {
    font-weight: 300;
    line-height: 2;
    color: #555;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-input {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
    opacity: 0;
    padding: 0;
}

.file-input:focus {
    outline: none;
}

.url-input {
    z-index: 1;
    flex-shrink: 0;
    background-color: #fff;
    border: 1px solid #09B07A;
    border-radius: 3px;
    padding: 8px 8px;
    width: 410px;
    max-width: 100%;
    font-size: .78rem;
    font-family: inherit;
    outline: none;
}

.params {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100px;
    border: 1px solid #09B07A;
    border-radius: 3px;
    width: 900px;
    margin: 0 auto;
}

.params1 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100px;
    border: 1px solid #FDA543;
    border-radius: 3px;
    width: 880px;
    margin: 0 auto;
}

.getObjectId {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 0.9rem;
    /* padding: 2px; */
    width: 130px;
    justify-content: center;
    font-weight: bold;
    color: #09B07A;
    background-color: #fff;
    border: 1px solid #09B07A;
    border-radius: 3px;
    cursor: pointer;
    align-items: center;
    height: 30px
}

.getObjectId:hover {
    color: #fff;
    background-color: #09B07A;
    border: 1px solid #09B07A;
}

.getObjectId1 {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 0.8rem;
    padding: 2px;
    width: 130px;
    justify-content: center;
    font-weight: bold;
    color: #FDA543;
    background-color: #fff;
    border: 1px solid #FDA543;
    border-radius: 3px;
    cursor: pointer;
    align-items: center;
}

.getObjectId1:hover {
    color: #fff;
    background-color: #FDA543;
    border: 1px solid #FDA543;
}

.getObjectId2 {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 0.8rem;
    padding: 10px 20px;
    margin-right: 10px;
    justify-content: center;
    font-weight: bold;
    color: #09B07A;
    background-color: #fff;
    border: 1px solid #09B07A;
    border-radius: 3px;
    cursor: pointer;
    align-items: center;
}

.getObjectId2:hover {
    color: #fff;
    background-color: #09B07A;
    border: 1px solid #09B07A;
}

.tag {
    color: #fff;
    background-color: #09B07A;
    border: 1px solid #09B07A;
}

.getObjectId3 {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 0.8rem;
    padding: 10px 20px;
    margin-right: 10px;
    justify-content: center;
    font-weight: bold;
    color: #555;
    background-color: #fff;
    border: 1px solid #555;
    border-radius: 3px;
    cursor: not-allowed;
}

.reset {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 1.2rem;
    padding: 5px 15px;
    font-weight: bold;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
}

.reset:hover {
    color: #fff;
    background-color: #F63D3A;
    border: 1px solid #F63D3A;
}

input[type=submit] {
    background-color: #09B07A;
    border: 0;
    border-radius: 3px;
    cursor: pointer;
    color: #fff;
    font-size: 1rem;
    padding: 5px 15px;
    font-weight: 700;
    width: 100px;
    font-family: inherit;
    text-transform: uppercase;
}

a {
    border-bottom: 1px dashed #09B07A;
    color: #09B07A;
    text-decoration: none;
}

a:hover {
    border-bottom: 1px solid #09B07A;
}

.select-selected {
    background-color: #fff;
    width: 284px;
    font-weight: 700;
    font-family: inherit;
    border: 1px solid #09B07A;
    border-radius: 3px;
    padding: 3px 5px;
    font-size: 1rem;
}

.select-selected1 {
    background-color: #fff;
    width: 284px;
    font-weight: 700;
    font-family: inherit;
    border: 1px solid #FDA543;
    border-radius: 3px;
    padding: 3px 5px;
    font-size: 1rem;
}

.params2 {
    display: flex;
    flex-direction: row;
    padding: 4px 5px;
    font-family: inherit;
    border: 1px solid #09B07A;
    border-radius: 3px;
    width: 274px;
    font-size: 1rem;
    font-weight: 700;
}

.params3 {
    display: flex;
    flex-direction: row;
    padding: 4px 5px;
    font-family: inherit;
    border: 1px solid #FDA543;
    border-radius: 3px;
    width: 274px;
    font-size: 1rem;
    font-weight: 700;
}

.params4 {
    display: flex;
    flex-direction: row;
    padding: 4px 5px;
    font-family: inherit;
    border: 1px solid #FDA543;
    border-radius: 3px;
    width: 273px;
    font-size: 1rem;
    font-weight: 700;
}

.file-drop-area.is-active {
    border: 1px solid #78C269;
    background-color: #78C269;
}

#table {
    box-shadow: 0 1px 2px rgba(0, 0, 0, .08), 0 5px 12px rgba(0, 0, 0, .04);
    font-size: 13px;
    /*margin: 0 5px;*/
    color: #FDA543;
}

#customers {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    border-radius: 3px;
    font-weight: bold;
}

#customers {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    border-radius: 3px;
    font-weight: bold;
}

#customers tr:first-child th:first-child {
    border-top-left-radius: 3px;
    padding: 6px;
}

#customers tr:last-child th:last-child {
    border-top-right-radius: 3px;
    padding: 6px;
}

#customers tr:last-child td:first-child {
    border-bottom-left-radius: 3px;
    padding: 6px;
}

#customers tr td:first-child {
    border-bottom-left-radius: 3px;
    padding: 6px;
}

#customers tr:last-child td:last-child {
    border-bottom-right-radius: 3px;
    padding: 6px;
}

#customers tr td {
    padding: 6px;
}


#customers tr:nth-child(even) {
    background-color: #f2f2f2;
}

#customers tr:hover {
    background-color: #ddd;
}

#customers th {
    padding-top: 6px;
    padding-bottom: 6px;
    background-color: #FDA543;
    color: white;
    white-space: nowrap;
    /* width: 200px; */
    overflow: hidden;
    text-overflow: ellipsis;
}

.load {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
}

.load hr {
    border: 0;
    margin: 0;
    width: 40%;
    height: 40%;
    position: absolute;
    border-radius: 50%;
    animation: spin 2s ease infinite
}

.load :first-child {
    background: #19A68C;
    animation-delay: -1.5s
}

.load :nth-child(2) {
    background: #F63D3A;
    animation-delay: -1s
}

.load :nth-child(3) {
    background: #FDA543;
    animation-delay: -0.5s
}

.load :last-child {
    background: #78C269
}

@keyframes spin {

    0%,
    100% {
        transform: translate(0)
    }

    25% {
        transform: translate(160%)
    }

    50% {
        transform: translate(160%, 160%)
    }

    75% {
        transform: translate(0, 160%)
    }
}

#alert {
    animation: blink 7s ease infinite
}

#alert:hover {
    animation: none
}

@keyframes blink {

    0%,
    100% {
        background-color: #FDA543
    }

    70% {
        background-color: #FDA543
    }

    75% {
        background-color: #fff
    }

    80% {
        background-color: #FDA543
    }

    85% {
        background-color: #fff
    }

    90% {
        background-color: #FDA543
    }

    95% {
        background-color: #fff
    }
}

li {
    list-style-type: none;
    display: inline-flex;
}

ul li span {
    /*color: #444;*/
    font-weight: bold;
}

ul {
    margin: 0 5px;
    padding: 0;
    text-align: left;
}

.upload {
    padding: 2px 5px;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid #FDA543
}

.upload:hover {
    background-color: #F63D3A;
    border: 1px solid #F63D3A;
    color: #fff
}

.loadDatasets {
    font-size: 1.1rem;
    font-weight: 700;
    padding: 3px 10px;
    color: #fff;
    background-color: #09B07A;
    border-radius: 3px;
    cursor: pointer;
}

.loadDatasets:hover {
    background-color: #78C269;
}

.active-tab {
    background-color: #FDA543;
    color: #fff;
}

.active-rejected {
    background-color: #F63D3A;
    color: #fff;
}

.sidenav__tabs {
    width: 200px;
    cursor: pointer;
}

.rightsection {
    width: 200px;
    cursor: pointer;
}

li {
    display: block;
    padding: 5px 10px 5px 10px
}

.tooltips {
    width: 390px;
    margin-right: 5px;
    height: 840px;
    padding: 15px;
    border: 1px solid #555;
    background-color: #fff;
    border-radius: 3px;
    opacity: 0.8;
    justify-content: flex-start;
    word-wrap: break-word;
}

.viz {
    border: 1px solid #78C269;
    border-radius: 3px;
}

.start {
    display: flex;
    justify-content: flex-start;
    font-weight: bold;
    word-wrap: break-word;
    padding-bottom: 5px;
}

.result {
    position: fixed;
    bottom: 20px;
    right: 30px;
    padding: 5px 15px;
    background-color: #fff;
    font-weight: bold;
    color: #09B07A;
    border-radius: 3px;
    width: 180px;
    border: 1px solid #09B07A;
    cursor: pointer;
}

.result:hover {
    padding: 5px 15px;
    background-color: #09B07A;
    color: #fff;
    border-radius: 3px;
    border: 1px solid #09B07A
}

.background {
    width: 100px;
    height: 50px;
    padding: 0;
    margin: 0;
}

.line {
    width: 100%;
    height: 100%;
    border-bottom: 2px solid #fff;
    transform: translateY(-23px) translateX(1px) rotate(20deg);
    position: absolute;
}

.background>div {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

.bottom {
    position: absolute;
    bottom: -1px;
    left: 0px;
    color: #555
}

.top {
    position: absolute;
    right: 20px;
    top: -3px;
}

.networkButton {
    display: flex;
    padding: 5px 10px;
    margin: 10px 0px;
    font-weight: bold;
    cursor: pointer;
    border: 1px solid #09B07A;
    border-radius: 3px;
    font-size: 0.8rem;
}

.networkButton:hover {
    color: #fff;
    background-color: #09B07A
}

.networkButton1 {
    display: flex;
    padding: 5px 10px;
    margin: 10px 0px;
    font-weight: bold;
    cursor: pointer;
    border: 1px solid #FDA543;
    color: #FDA543;
    border-radius: 3px;
    font-size: 0.8rem
}

.networkButton1:hover {
    color: #fff;
    background-color: #FDA543
}

.grabbable {
    cursor: move;
    /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.grabbable:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}

.clear {
    font-size: 0.9rem;
    font-weight: 700;
    width: 130px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 173px
}

.clear:hover {
    background-color: #F63D3A;
    color: #fff;
}

.clear1 {
    font-size: 1rem;
    font-weight: 700;
    width: 130px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 163px
}

.clear1:hover {
    background-color: #F63D3A;
    color: #fff;
}

.clear2 {
    font-size: 1rem;
    font-weight: 700;
    width: 130px;
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
}

.clear2:hover {
    background-color: #F63D3A;
    color: #fff;
}

.clearAll {
    font-size: 0.8rem;
    font-weight: 700;
    width: 130px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
    height: 30px;
}

.clearAll:hover {
    background-color: #F63D3A;
    color: #fff;
}

.clearAll2 {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 0.8rem;
    padding: 10px 20px;
    justify-content: center;
    font-weight: bold;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
    align-items: center;
}

.clearAll2:hover {
    color: #fff;
    background-color: #F63D3A;
    border: 1px solid #F63D3A;
}

.clearAll1 {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 0.8rem;
    padding: 2px;
    width: 130px;
    justify-content: center;
    font-weight: bold;
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    border-radius: 3px;
    cursor: pointer;
    align-items: center;
}

.clearAll1:hover {
    color: #fff;
    background-color: #F63D3A;
    border: 1px solid #F63D3A;
}

.active-clearall {
    display: flex;
    justify-content: center;
    /*width: 200px;*/
    color: #F63D3A;
    background-color: #fff;
    border: 1px solid #F63D3A;
    cursor: pointer;
}

.active-clearall:hover {
    color: #fff;
    background-color: #F63D3A;
}

.clearAll1 {
    display: flex;
    position: absolute;
    visibility: hidden;
}

.number {
    padding: 2px 7px;
    border-radius: 50%;
    background-color: #FDA543;
    color: #fff;
    margin-right: 5px;
    font-weight: bold;
}

.scroll {
    max-height: 294px;
    overflow-y: scroll;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
}

.scroll::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
}

.scroll thead th {
    position: sticky;
    top: 0;
}

th span.sort-by {
    padding-right: 18px;
    position: relative;
}

span.sort-by:before,
span.sort-by:after {
    border: 4px solid transparent;
    content: "";
    display: block;
    height: 0;
    right: 5px;
    top: 50%;
    position: absolute;
    width: 0;
}

span.active:before {
    border-bottom-color: #777;
    margin-top: -9px;
}

span.active:after {
    border-top-color: #777;
    margin-top: 1px;
}

span.active-decs:before {
    border-bottom-color: #777;
    margin-top: -9px;
}

span.active-decs:after {
    border-top-color: #fff;
    margin-top: 1px;
}

span.active-acs:before {
    border-bottom-color: #fff;
    margin-top: -9px;
}

span.active-acs:after {
    border-top-color: #777;
    margin-top: 1px;
}

.tooltip {
    text-align: left;
    display: inline-block;
    position: relative;
}

.tooltip .trigger {
    display: inline-block;
    z-index: 1;
    text-decoration: none;
    cursor: help;
}

.tooltip .trigger::before {
    content: '';
    opacity: 0;
    visibility: hidden;
    position: absolute;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    transition: all 150ms ease-in-out;
    padding-right: 14px;
}

.tooltip .content {
    display: inline-block;
    z-index: 2;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    background-color: #FDA543;
    color: white;
    padding: 0 1rem;
    border-radius: 3px;
    width: 200px;
    font-size: 0.8rem;
    transition: all 150ms ease-in-out;
}

.tooltip .content {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
}

.tooltip .trigger::before {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

.tooltip .content {
    top: 100%;
    left: 15%;
}

.tooltip.left .trigger::before {
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-left-color: #FDA543;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
}

.tooltip.left .content {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
}

.tooltip.left .trigger::before {
    border-right: none;
    top: 50%;
    transform: translateY(-50%);
    right: 100%;
}

.tooltip.left .content {
    top: -12%;
    right: 110%;
    right: calc(100% + 20px);
}

.tooltip:hover .trigger::before {
    opacity: 1;
    visibility: visible;
}

.tooltip:hover .content {
    opacity: 1;
    visibility: visible;
}

.tooltip .trigger:focus::before {
    opacity: 1;
    visibility: visible;
}

.tooltip .trigger:focus+.content {
    opacity: 1;
    visibility: visible;
}

.better {
    text-align: center;
    font-weight: bold;
}

.tooltip {
    display: inline;
    -webkit-perspective: 500px;
    -moz-perspective: 500px;
    perspective: 500px;
}

.tooltip:hover {
    cursor: pointer;
}

.tooltip:hover .tooltip__content {
    -webkit-transform: translate3d(-50%, -10%, 0);
    -moz-transform: translate3d(-50%, -10%, 0);
    -ms-transform: translate3d(-50%, -10%, 0);
    -o-transform: translate3d(-50%, -10%, 0);
    transform: translate3d(-50%, -10%, 0);
    opacity: 1;
    pointer-events: auto;
}

.tooltip__content {
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    transition: all 200ms ease;
    -webkit-transform: translate3d(-50%, 0%, 0);
    -moz-transform: translate3d(-50%, 0%, 0);
    -ms-transform: translate3d(-50%, 0%, 0);
    -o-transform: translate3d(-50%, 0%, 0);
    transform: translate3d(-50%, 0%, 0);
    -webkit-transform-origin: 0 10px;
    -moz-transform-origin: 0 10px;
    -ms-transform-origin: 0 10px;
    -o-transform-origin: 0 10px;
    transform-origin: 0 10px;
    background-color: #fff;
    border-radius: 4px;
    color: #fff;
    display: block;
    font-size: 14px;
    font-weight: normal;
    left: 50%;
    width: 240px;
    opacity: 0;
    padding: 10px 20px;
    pointer-events: none;
    position: absolute;
    text-align: left;
    bottom: 100%;
    background-color: #FDA543
}

.tooltip__content:before {
    border-color: transparent;
    border-top-color: #FDA543;
    border-style: solid;
    border-width: 10px;
    content: ' ';
    display: block;
    height: 0;
    left: 50%;
    margin-left: -10px;
    position: absolute;
    bottom: -20px;
    width: 0;
}

.tooltip__content:after {
    content: ' ';
    display: block;
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    height: 20px;
}

.tooltip__content:hover {
    -webkit-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
    -moz-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
    -ms-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
    -o-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
    transform: rotateX(0deg) translate3d(-50%, -10%, 0);
    opacity: 1;
    pointer-events: auto;
}

.legend {
    font-size: .9rem;
    font-weight: bold;
    padding: 5px 15px;
    color: #fff;
    background-color: #09B07A;
    border: 1px solid #09B07A;
    border-radius: 3px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-self: flex-start;
}
</style>